import { default as DateTimeComponent } from "react-datetime";
import "./react-datetime.css";

export const DateTime = DateTimeComponent;
